import { gql } from '@apollo/client';

export default gql`
  query getOperationById($opId: String) {
    getOperationById(opId: $opId) {
      ok
      error
      data {
        _id
        id
        time
        opType

        branch
        title
        desc
        startDate
        endDate
        duration
        allDay
        rRule
        reminder
        exDate
        allowDrag
        groupId
        locationLink
        address
        houseno
        autoNo
        docNo
        temp
        priority
        amount
        status
        nots
        activenots
        smss
        activesmss

        bonos
        overtime
        absent
        daytime

        customerId
        customerName
        customerNameAr
        customerPhone

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeeColor
        employeePhone
        workersIds

        projectId
        projectName
        projectNameAr
        projectColor
        resourseId
        resourseName
        resourseNameAr
        resourseColor

        contractId
        contractName
        contractNameAr

        contactId
        contactName
        contactNameAr

        retypeId
        retypeName
        retypeNameAr
        retypeColor

        retype2Id
        retype2Name
        retype2NameAr
        retype2Color

        dcategoryId
        dcategoryName
        dcategoryNameAr
        gref

        invoiceId
        link
        sent
        paid
        invoiced
        procs

        signatureName
        signatureImage

        createUser
        activeUser

        refNo
        refType
        userId
        createdAt
        updatedAt
      }
    }
  }
`;
